import { DialogUtility } from '@syncfusion/ej2-popups';
import debounce from 'lodash/debounce';

import IpaAdministrationWizard from 'components/ProviderData/IpaAdministration/organisms/IpaAdministrationWizard/IpaAdministrationWizard';
import { Dialog } from 'interfaces/Dialog';
import { dialogService } from 'subjects/common/DialogService';

export const asyncDebounce = (func, wait) => {
    const debounced = debounce((resolve, reject, args) => {
        func(...args)
            .then(resolve)
            .catch(reject);
    }, wait);
    return (...args) =>
        new Promise((resolve, reject) => {
            debounced(resolve, reject, args);
        });
};

export const fillWithZeros = (value, decimals) => {
    const valueSplitted = value !== 0 ? `${value}`.split('.') : '';
    if (valueSplitted) {
        if (valueSplitted.length === 1) {
            return parseFloat(value).toFixed(decimals);
        } else if (valueSplitted.length > 1) {
            const paddedDecimals = valueSplitted[1].padEnd(decimals, '0');
            return `${valueSplitted[0]}.${paddedDecimals}`;
        }
        return value;
    }
};

interface ConfirmationArgs {
    title?: string;
    message: string;
    width?: number;
    confirmBtnText?: string;
    cancelBtnText?: string;
    showCloseIcon?: boolean;
    closeOnEscape?: boolean;
}
export const showConfirmation = async ({
    title,
    message,
    width = undefined,
    confirmBtnText = 'Confirm',
    cancelBtnText = 'Cancel',
    showCloseIcon = true,
    closeOnEscape = true,
}: ConfirmationArgs) => {
    return new Promise((resolve) => {
        const alert = DialogUtility.confirm({
            animationSettings: { effect: 'None' },
            isModal: true,
            width,
            content: message,
            showCloseIcon,
            closeOnEscape,
            cancelButton: {
                text: cancelBtnText,
                cssClass: 'e-cancel mt-2',
                click: () => {
                    alert.hide();
                    resolve(false);
                },
            },
            okButton: {
                text: confirmBtnText,
                cssClass: 'e-submit mt-2',
                click: () => {
                    alert.hide();
                    resolve(true);
                },
            },
            title,
            position: { X: 'center', Y: 'center' },
        });
    });
};

export const createIpaMember = (ipaId, isCopyToNew) => {
    const dialog: Dialog = {
        header: 'Create New',
        content: () => (
            <div
                className={'col'}
                style={{ height: '460px' }
                }
            >
                <IpaAdministrationWizard
                    ipaId={ipaId}
                    isCopyToNew={isCopyToNew ?? false}
                />
            </div>
        ),
        width: '80%',
        height: '80%',
    };
    dialogService.open(dialog);
};

export const showIPAEndDateIsInThePastWarningDialog = () => {
    const dialog: Dialog = {
        header: 'WARNING:  Entity Termination',
        content: () => (
            <div
                className={'col'}
                style={{fontSize: "14px"}}
            >
                You will be terminating this IPA.
                If a new sequence will be created, please remember to create the related configurations.
            </div>
        ),
        width: '700px',
        height: '250px',
        buttons: [
            {
                buttonModel: {
                    content: 'Ok',
                    iconCss: 'e-icons e-checkMark',
                    cssClass: 'e-submit',
                },
                click: () => {
                    dialogService.close();
                },
            },
        ],
    };
    dialogService.open(dialog);
};

export const permissionLevels = {
    edit: 'edit',
    readOnly: 'read-only',
    none: 'no-permission',
};
